import React, { useEffect, useReducer, useState } from "react";
import styles from './EarningPoints.module.scss'
import { Button } from "components/Buttons/Buttons";
import { Dropdown, Menu, Modal, Select, Space, Table, Button as AntdButton } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import useSettingsHeader from "hooks/useSettingsHeader";
import { useDispatch } from "react-redux";
import { deleteEarningPoint, getAllEarningPoints } from "services/earningPoints.service";
import SearchAndFilterColumns from "components/SearchAndFilterColumns/SearchAndFilterColumns";
import usePortal from "hooks/usePortal";
import moment from "moment";
import { setLoading } from "redux/actions/app.actions";
import EarningPointsAddEditModal from "./components/EarningPointsAddEditModal";
import { getAllBoosts, getAllServices } from "services/servicesAndBoostsSettings.service";
import { getAllTaxCategories } from "services/taxation.service";
import { getAllCategories } from "services/categoriesSettings.services";
import { push } from "connected-react-router";


const reducer = (state, action) => {
    switch (action.type) {
        case "SET":
            return action.data;
        case "ADD":
            return [...state, action.data];
        default:
            return state;
    }
};


export default function EarningPoints() {
    const [showAddEditModal, setShowAddEditModal] = useState();
    const [data, localDispatch] = useReducer(reducer, []);
    const [hiddenColumns, setHiddenColumns] = useState([]);
    const [activeFilter, setActiveFilter] = useState("active"); // all, active, inactive
    const [searchText, setSearchText] = useState("");

    const [products, setProducts] = useState({
        isLoading: true,
        data: [],
    });
    const [addOns, setAddOns] = useState({
        isLoading: true,
        data: [],
    });
    const [categories, setCategories] = useState({
        isLoading: true,
        data: [],
    });

    const dispatch = useDispatch();
    // use effect starts
    const loadData = async () => {
        const result = await dispatch(getAllEarningPoints());
        if (result?.status === "success") {
            localDispatch({
                type: "SET",
                data: result.data,
            });
        }
    };
    useEffect(() => {
        loadData();
        Promise.all([
            dispatch(getAllServices(false)),
            dispatch(getAllBoosts(false)),
        ]).then((result) => {
            const [resultServices, resultBoosts] = result;

            if (resultServices?.status === "success") {
                setProducts({
                    isLoading: false,
                    data: resultServices.data?.map?.((product) => {
                        product.productName = product.productName + " (Service)";
                        return product;
                    }) ?? []
                }
                );
            }
            if (resultBoosts?.status === "success") {
                setAddOns(
                    {
                        isLoading: false,
                        data: resultBoosts.data?.map?.((product) => {
                            product.productName = product.productName + " (Boost)";
                            return product;
                        }) ?? []
                    }
                );
            }
        });
        dispatch(getAllCategories(false)).then((result) => {
            if (result?.status === "success") {
                setCategories({
                    isLoading: false,
                    data: result.data ?? []
                });
            }
        });
    }, []);
    // use effects end

    const checkActiveFilter = (item) => {
        if (activeFilter === "all") return true;
        else if (activeFilter === "active" && item?.isActive) return true;
        else if (activeFilter === "inactive" && !item?.isActive) return true;
        return false;
    };


    const handleDelete = (id) => {
        dispatch(deleteEarningPoint(id), loadData)
    };

    const deleteConfirmation = (id) => ({
        title: "Delete Earning Points",
        content: <>Are you sure that you want to delete the earning points?</>,
        centered: true,
        maskClosable: true,
        onOk: (close) => {
            handleDelete(id);
            close();
        },
    });



    const settingHeaderContent = useSettingsHeader(
        <Space align="center" size="large">
            {/* <AntdButton
                type="text"
                style={{ padding: 0, lineHeight: 1 }}
                onClick={() => dispatch(push("/dashboard/settings/points-value-policy"))}
            >
                Manage Points Value Policy
            </AntdButton> */}
            <Button
                rounded={true}
                onClick={() => {
                    setShowAddEditModal(true);
                }}
            >
                Create Earning Points
            </Button>
        </Space>
    );

    const columns = [
        {
            title: "Policy Name",
            dataIndex: "name",
            key: "name",
            sorter: (a, b) => {
                if (a.name?.toLowerCase?.() < b.name?.toLowerCase?.())
                    return -1;
                if (a.name?.toLowerCase?.() > b.name?.toLowerCase?.())
                    return 1;
                return 0;
            },
        },
        {
            title: "Points Per Dollar",
            dataIndex: "pointsPerDollar",
            key: "pointsPerDollar",
            sorter: (a, b) => {
                if (a.pointsPerDollar < b.pointsPerDollar)
                    return -1;
                if (a.pointsPerDollar > b.pointsPerDollar)
                    return 1;
                return 0;
            },
        },
        {
            title: "From",
            dataIndex: "fromDate",
            key: "fromDate",
            sorter: (a, b) => {
                if (a.fromDate < b.fromDate)
                    return -1;
                if (a.fromDate > b.fromDate)
                    return 1;
                return 0;
            },
            render: (record) => {
                return moment(record).format("MM/DD/YYYY");
            },
        },
        {
            title: "To",
            dataIndex: "toDate",
            key: "toDate",
            sorter: (a, b) => {
                if (!a.toDate && !b.toDate) return 0;
                if (!a.toDate) return 1;
                if (!b.toDate) return -1;
                if (a.toDate < b.toDate)
                    return -1;
                if (a.toDate > b.toDate)
                    return 1;
                return 0;
            },
            render: (record) => {
                return record ? moment(record).format("MM/DD/YYYY") : "-";
            },
        },
        {
            title: "Status",
            key: "status",
            width: 120,
            render: (record) => {
                return record?.isActive ? "Active" : "Inactive";
            },
        },
        {
            title: "",
            key: "action",
            align: "right",
            width: 80,
            render: (record) => {
                return (
                    <Dropdown
                        overlay={
                            <Menu style={{ borderRadius: 6, border: "2px solid #CDD5D8 " }}>
                                <Menu.Item
                                    onClick={() => setShowAddEditModal(record)}
                                    key="edit"
                                >
                                    Edit
                                </Menu.Item>
                                <Menu.Item
                                    key="delete"
                                    onClick={() => { Modal.warning(deleteConfirmation(record.loyaltyPolicyId)) }}
                                >
                                    Delete
                                </Menu.Item>
                            </Menu>
                        }
                        trigger={["click"]}
                        getPopupContainer={(triggerNode) => triggerNode?.parentNode}
                    >
                        <MoreOutlined style={{ fontSize: 18 }} />
                    </Dropdown>
                );
            },
        },
    ];

    const searchAndFiltersContent = usePortal(
        "#settingHeader .settingsHeaderLeftSideAddon",
        <Space>
            <SearchAndFilterColumns
                columns={columns}
                hiddenColumns={hiddenColumns}
                setHiddenColumns={(columnTitles) => {
                    setHiddenColumns(columnTitles);
                }}
                searchText={searchText}
                setSearchText={(text) => {
                    setSearchText(text);
                }}
            />
            {/* <Select
                style={{ width: 120 }}
                value={activeFilter}
                onChange={(value) => {
                    setActiveFilter(value);
                }}
                options={[
                    {
                        value: "all",
                        label: "All",
                    },
                    {
                        value: "active",
                        label: "Active",
                    },
                    {
                        value: "inactive",
                        label: "Inactive",
                    },
                ]}
            /> */}
        </Space>
    );

    return (
        <div>
            {settingHeaderContent}
            {searchAndFiltersContent}
            <Table
                rowKey={(data) => data.categoryId}
                tableLayout="auto"
                locale={{ emptyText: "No Earning Points Found" }}
                dataSource={data?.filter(
                    (it) =>
                        checkActiveFilter(it) &&
                        it?.name
                            ?.toLowerCase?.()
                            .includes?.(searchText.toLowerCase())
                )}
                columns={columns.filter((column) => {
                    if (!hiddenColumns.includes(column.title)) return true;
                    return false;
                })}
                pagination={{
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    pageSizeOptions: [15, 25, 50, 100, 250],
                }}
            // scroll={{ y: "calc(100vh - 80px - 96px - 60px - 100px)", x: true }}
            />
            <EarningPointsAddEditModal
                data={showAddEditModal}
                services={products.data}
                isServicessLoading={products.isLoading}
                addons={addOns.data}
                isAddOnsLoading={addOns.isLoading}
                categories={categories.data}
                isCategoriesLoading={categories.isLoading}
                visible={showAddEditModal}
                // taxCategories={taxCategories}
                onCancel={() => {
                    setShowAddEditModal();
                }}
                onSuccess={() => {
                    setShowAddEditModal();
                    loadData();
                }}
            />
        </div>
    )
}
